<template>
  <div
          v-b-tooltip.hover
          :title="$t('global.click_to_expand')"
          v-html="subscriptions"
          class="pointer"
          @click="expand = !expand">
  </div>
</template>

<script>

  export default {
    name: 'ColumnSubscriptions',
    props: {
      row: {
        type: Object
      },
      index: {
        type: [Number, String]
      },
      column: {
        type: [String]
      },
      name: {
        type: String,
        default: 'subscriptions'
      },
      initialExpand: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
          expand: false
      }
    },
    mounted () {
      this.expand = this.initialExpand
    },
    methods: {
      getSubscriptionHTML (subs) {
        let subscriptionsHtml = '';
        if (subs.plan.title) {
          subscriptionsHtml += `<b>Plan:</b> ${subs.plan.title}<br>`
        }
        if (subs.title) {
          subscriptionsHtml += `<b>Subscription:</b> ${subs.title}<br>`
        }
        if (this.expand) {
            subscriptionsHtml += `<b>Start:</b> ${ subs.subscription_start_date ? this.formatDate(subs.subscription_start_date, 'L') : 'N/A'}<br>`
            subscriptionsHtml += `<b>End:</b> ${ subs.subscription_end_date ? this.formatDate(subs.subscription_end_date, 'L') : 'N/A'}<br>`
            subscriptionsHtml += subs.autorenew ? `<b>Auto Renew:</b> Yes<br>` : `<b>Auto Renew:</b> No<br>`
        }
        return subscriptionsHtml;
      }
    },
    computed: {
        subscriptions: {
        cache: false,
        get: function () {
          const subscriptions = this.row[this.name];

          let subscriptionsHtml = '';

          if(Array.isArray(subscriptions)) {
            subscriptions.forEach(subs => {
              subscriptionsHtml += this.getSubscriptionHTML(subs)
            });
          } else if (typeof (subscriptions) === 'object') {
            subscriptionsHtml += this.getSubscriptionHTML(subscriptions)
          }

            subscriptionsHtml = subscriptionsHtml === '' ? 'Not Set' : subscriptionsHtml;
          return subscriptionsHtml
        }
      }
    }
  }
</script>
